import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export const enum SocialAlert {
  NONE,
  GOOGLE,
  APPLE,
}

export const SocialAlertsContext = createContext<
  Dispatch<SetStateAction<SocialAlert>>
>(() => {});

export const useSocialAlerts = () => useContext(SocialAlertsContext);
